import { StyledTitle } from "components/general/stylingHero";
import { useState } from "react";
import styled from "styled-components";

const StyledRow = styled.div`
  display: flex;
  gap: 2rem;
  margin-bottom: 3rem;
`;
const StyledSlider = styled.input`
  flex: 1;
  accent-color: #5a87f5;
`;
const StyledLabel = styled.label`
  font-size: 1.2rem;
`;
const EarningsCalculator = () => {
  const [pannualReferrals, setpannualReferrals] = useState(45);
  const [uannualReferrals, setuannualReferrals] = useState(15);
  const [plifeReferrals, setplifeReferrals] = useState(7);
  const [ulifeReferrals, setulifeReferrals] = useState(2);

  const calculateTotal = () => {
    return (
      (pannualReferrals * 95.88 +
        uannualReferrals * 180 +
        plifeReferrals * 245 +
        ulifeReferrals * 445) *
      0.5
    ).toFixed(2);
  };

  return (
    <div style={{ marginTop: "3rem", padding: "0 2rem" }}>
      <StyledTitle>
        You will earn <span style={{ color: "#7255c8" }}>${calculateTotal()}</span>
      </StyledTitle>
      <div style={{ textAlign: "center", fontSize: "1.2rem", marginBottom: "3rem" }}>
        Minimum cashout is $50
      </div>

      <StyledRow>
        <StyledLabel>
          Premium Yearly
          <br /> $95/yr
        </StyledLabel>
        <StyledSlider
          type="range"
          min="0"
          max="100"
          value={pannualReferrals}
          onChange={(e) => setpannualReferrals(e.target.value)}
        />
        <StyledLabel>
          <b>{pannualReferrals}</b>
          <br /> referrals
        </StyledLabel>
      </StyledRow>

      <StyledRow>
        <StyledLabel>
          Premium Lifetime
          <br /> $245/lifetime
        </StyledLabel>
        <StyledSlider
          type="range"
          min="0"
          max="100"
          value={plifeReferrals}
          onChange={(e) => setplifeReferrals(e.target.value)}
        />
        <StyledLabel>
          <b>{plifeReferrals}</b>
          <br /> referrals
        </StyledLabel>
      </StyledRow>

      <StyledRow>
        <StyledLabel>
          Ultimate Yearly
          <br /> $180/yr
        </StyledLabel>
        <StyledSlider
          type="range"
          min="0"
          max="100"
          value={uannualReferrals}
          onChange={(e) => setuannualReferrals(e.target.value)}
        />
        <StyledLabel>
          <b>{uannualReferrals}</b>
          <br /> referrals
        </StyledLabel>
      </StyledRow>

      <StyledRow>
        <StyledLabel>
          Ultimate Lifetime
          <br /> $445/lifetime
        </StyledLabel>
        <StyledSlider
          type="range"
          min="0"
          max="100"
          value={ulifeReferrals}
          onChange={(e) => setulifeReferrals(e.target.value)}
        />
        <StyledLabel>
          <b>{ulifeReferrals}</b>
          <br /> referrals
        </StyledLabel>
      </StyledRow>
    </div>
  );
};

export default EarningsCalculator;
